import { mapActions } from "vuex";
import moment from "moment";
import statusFilter from '@/components/filter'
import draggable from 'vuedraggable'
import _ from "lodash";
export default {
    name: "orderList",
    components: {
        draggable,
        statusFilter
    },
    data() {
        return {
            srcList:"",
            filterList1:[
                { label: "待竞价", value: 501 },
                { label: "竞价中", value: 502 },
                { label: "待确认定标", value: 503 },
            ],
            filterList2:[
                { label: "未指派人车", value: 1 },
                { label: "已指派人车", value: 2 },
            ],
            filterList3:[
                { label: "未确认收货", value: 1 },
                { label: "已确认收货", value: 2 },
            ],
            filterList4:[
                { label: "货主取消", value: 506 },
                { label: "已流标", value: 505 },
            ],
            isDataFromSessionStrorage: false,
            dataOwner: [],
            cancelLoading: false,
            monitors: [],
            etcFenceDistanceMap: {},
            bidContacts: '',
            cdTmIns: null,
            show: {
                OrderList_Export: false,
                OrderList_Cancel: false,
                OrderUpdate: false,
                OrderList_Ensure: false,
                OrderList_Query: false
            },
            bidDay: 0,
            bidHour: 0,
            bidMinute: 0,
            bidSecond: 0,
            bid_orderId: null,
            isTaskConflict: 0,
            bargainPrice: null,
            expectPrice: null,
            floatingRatio: 0,
            page: 'orderList',
            checkpictureVisible: false,
            configColsVisible: false,
            loading: false,
            exportLoading: false,
            vehicleMap: [{
                "plVehicleType": "厢式",
                "plVehicleCode": "300",
                "grdVehicleCode": "002001"
            },
            {
                "plVehicleType": "平板",
                "plVehicleCode": "350",
                "grdVehicleCode": "002007"
            },
            {
                "plVehicleType": "高栏",
                "plVehicleCode": "450",
                "grdVehicleCode": "002024"
            },
            {
                "plVehicleType": "特种运输",
                "plVehicleCode": "600",
                "grdVehicleCode": "002025"
            },
            {
                "plVehicleType": "封闭式一体货车/客车",
                "plVehicleCode": "100",
                "grdVehicleCode": "002016"
            },
            {
                "plVehicleType": "冷藏车",
                "plVehicleCode": "900",
                "grdVehicleCode": "002013"
            }],
            SFMap: window.SFMap,
            mode: '1',
            form: {
                assignState: '',
                ensureState: '',
                carrierType: '',
                planOrderId: '',
                deliveryFlag: '',
                dataOwner: '',
                planDepartTm: [],
                dispatchMode: '',
                createType: '',
                dealState: '',
                orderId: '',
                src: '',
                dest: '',
                userName: '',
                carrier: '',
                driverName: '',
                vehicle: '',
                company: '',
                needReceipt: '',
                createTm: [],
                start: '',
                end: '',
                requireType: '',
                pageNum: 1,
                pageSize: 10,
            },
            total: 0,
            tabs: {
                activeName: 0,
                label: '全部',
                label1: '待接单',
                label2: '待装货',
                label3: '运输中',
                label4: '收货中',
                label5: '已取消',
                label11: '待结算',
                label10: '已完成',
                label9: '已中止',
                label12: '异常',
            },
            orderStateOptions: [
                {
                    value: '',
                    label: '全部',
                },
                {
                    value: '1',
                    label: '待接单',
                },
                {
                    value: '2',
                    label: '待装货',
                    children: [
                        {
                            value: '99',
                            label: '待指派人车',
                        },
                        {
                            value: '98',
                            label: '已指派人车',
                        }
                    ]
                },
                {
                    value: '3',
                    label: '运输中',
                },
                {
                    value: '4',
                    label: '收货中',
                    children: [
                        {
                            value: '97',
                            label: '未确认收货',
                        },
                        {
                            value: '96',
                            label: '已确认收货',
                        }
                    ]
                },
                {
                    value: '5',
                    label: '已取消',
                },
                {
                    value: '11',
                    label: '待结算',
                },
                {
                    value: '10',
                    label: '已完成',
                },
                {
                    value: '9',
                    label: '已中止',
                },
                {
                    value: '12',
                    label: '异常',
                },
            ],
            table: [],
            detail: {
                map: {
                    carNewestPosMarker: null,
                    mapIns: '',
                    polyline: '',
                    pointLayer: null,
                    planLayer: [],
                    carLayer: [],
                    phoneLayer: [],
                    truckMainCoordinate: [],
                    planGPS: false,
                    carGPS: false,
                    phoneGPS: false,
                    coordinates: [],
                    planCoordinates: [],
                    carCoordinates: [],
                    phoneCoordinates: [],
                },
                order: {
                    title: '-'
                    , status: {
                        status: true,
                        status1: false,
                        status2: false,
                        status3: false,
                    }
                    , state: ''
                    , statusName: '运输中'
                    , orderId: ''
                    , outerOrderId: ''
                    , customerWaybillId: ''
                    , planArriveTm: ''
                    , reachTm: ''
                    , totalPrice: ''
                    , needReceipt: ''
                    , needReceiptImg: ''
                    , needReceiptSrc: ''
                    , dataOwner: ''
                    , projectName: ''
                    , distance: ''
                    , runTm: ''
                    , cargoInfo: ''
                    , cargoWeight: ''
                    , cargoVolume: ''
                    , mode: ''
                    , carType: ''
                    , vehicleType: ''
                    , vehicleLength: ''
                    , comment: ''
                    , priceRule: ''
                    , price: ''
                    , passZones: []
                    , saasRouteInfos: []
                    , opLogs: []
                    , srcCity: ''
                    , vehicleSerial: ''
                    , taskId: ''
                    , biddingVO: {
                        biddingEndTm: null,
                        biddingStartTm: null,
                        dealState: null,
                        enterUserCount: null,
                        expectPrice: null,
                        floatPercentage: null,
                        joinUserCount: null,
                        lowestPrice: null,
                        totalPrice: null,
                    }
                    , deductionInfoResponses: [],
                    requireType:'',
                },
                table: [],
                logData: [],
            },
            orderDetailVisible: false,
            cancelVisible: false,
            bidVisible: false,
            progress: 0,
            cancelForm: {
                rules: {
                    deleteReason: [{ required: true, message: "请选择取消原因", trigger: "change" }]
                },
                orderId: '',
                deleteReason: '',
                deleteReasonDesc: '',
            },
            detailGoodsInfoTableList: [],//提送货货物信息列表数据
            detailGoodsInfoTableTotal: 0,
            goodsInfoTableCurrentPage: 1,
            goodsInfoTablePageSize: 10,
            sendDeliveryCount: 0,//送货数量总计
            takeDeliveryCount: 0,//提货数量总计
            testPosition1: 0,
            testArr1: [],
            serviceDetailArry: [],
            showServiceDetail: false,
            checkDetailOrderId: '',
            detailDeliveryFlag: false
        }
    },
    filters: {
        payEndDateFilter(val){
            if(!val){
              return ''
            }    
            return moment(val).format('YYYY-MM-DD HH꞉mm꞉ss')
        },
    },
    methods: {
        ...mapActions([
            'getOrderListApi',
            'exportApi',
            'getOrderDetailApi',
            'cancelOrderApi',
            'ensureOrderApi',
            'queryReceiptApi',
            'queryTrackApi',
            'queryBidDetailApi',
            'confirmBidApi',
            'initPlaceApi',
            'viewImgApi',
            'getGoodListInfoApi'
        ]),
        // 获取货物列表信息
        getGoodListInfo() {
            let parama = {
                'orderId': this.checkDetailOrderId,
                "pageNum": this.goodsInfoTableCurrentPage, 
                "pageSize": this.goodsInfoTablePageSize
            }
            this.getGoodListInfoApi(parama).then(res => {
                this.detailGoodsInfoTableList = res.rows;
                this.detailGoodsInfoTableTotal = res.totalCount;
                if(this.detailGoodsInfoTableList.length > 0) {
                    this.sendDeliveryCount = this.detailGoodsInfoTableList[0].sendDeliveryCount;//送货数量总计
                    this.takeDeliveryCount = this.detailGoodsInfoTableList[0].takeDeliveryCount;//提货数量总计
                }else{
                    this.sendDeliveryCount = 0;
                    this.takeDeliveryCount = 0;
                }
                if(this.detailGoodsInfoTableList && this.detailGoodsInfoTableList.length>0) {
                    this.testPosition1 = 0;
                    this.testArr1 = [];
                    this.rowspan(this.testArr1, this.testPosition1, "goodsOrderId")
                }
            });
        },
        // 点击详情增值服务数据
        clickzzfw(row) {
            this.serviceDetailArry = row.appreciationServiceDtoList || [];
            this.showServiceDetail = true;
        },
        // 货物信息弹框点击查看
        checkDetail(row) {
            switch(row.dataType) {  //1提货单 2送货单
                case 1:
                    sessionStorage.setItem('manifestDeatilParama',JSON.stringify(
                        {
                            dataType: '1',
                            goodsOrderId: row.goodsOrderId,
                            outerOrderId: row.outerOrderId
                        }
                    ));
                    this.$router.push('/manage/orderGetManifestDetail');
                    break;
                case 2:
                    sessionStorage.setItem('manifestDeatilParama',JSON.stringify(
                        {
                            dataType: '2',
                            goodsOrderId: row.goodsOrderId,
                            outerOrderId: row.outerOrderId
                        }
                    ));
                    this.$router.push('/manage/orderSetManifestDetail');
                    break;
                default:
                    return false;
            }
        },
        // 提送货信息列表合并
        rowspan(spanArr, position, spanName) {
            this.detailGoodsInfoTableList.forEach((item, index) => {
                if (index === 0) {
                    spanArr.push(1)
                    position = 0
                } else {
                    if ( this.detailGoodsInfoTableList[index][spanName]===this.detailGoodsInfoTableList[index - 1][spanName] ) {
                        spanArr[position] += 1
                        spanArr.push(0)
                    } else {
                        spanArr.push(1)
                        position = index
                    }
                }
            });
        },
        objectSpanMethod({ row, column, rowIndex, columnIndex }) {
            if (column.property!="goodsName"&&column.property!="quantity"&&column.property!="calculateUnit"&&column.property!="totalWeight"&&column.property!="totalCapacity") {
                const _row = this.testArr1[rowIndex]
                const _col = _row > 0 ? 1 : 0
                return {
                    rowspan: _row,
                    colspan: _col,
                }
            }else{
                return{
                    rowspan: [],
                    colspan: [],
                }
            }
        },
        // 提送货类型格式化
        typeFormatter(row) {
            switch(row.dataType) {
            case 1:
            case '1':
                return '提货单'
                break;
            case 2:
            case '2':
                return '送货单'
                break;
            default:
                return type
            }
        },
        goosdInfoHandleSizeChange(val) {
            this.goodsInfoTableCurrentPage = 1;
            this.goodsInfoTablePageSize = parseInt(val);
            this.getGoodListInfo();
        },
        goosdInfoHandleCurrentChange(val) {
            this.goodsInfoTableCurrentPage = parseInt(val);
            this.getGoodListInfo();
        },
        // 点击详情-提货单号跳转提货单详情页
        toGetManifestInfoPage(row) {
            sessionStorage.setItem('manifestDeatilParama',JSON.stringify(
                {
                    dataType: '1',
                    goodsOrderId: row.pickupGoodsOrderId,
                    outerOrderId: row.outerOrderId
                }
            ));
            this.$router.push('/manage/orderGetManifestDetail');
        },
        // 点击详情-送货单号跳转提货单详情页
        toSetManifestInfoPage(row) {
            sessionStorage.setItem('manifestDeatilParama',JSON.stringify(
                {
                    dataType: '2',
                    goodsOrderId: row.deliveryGoodsOrderId,
                    outerOrderId: row.outerOrderId
                }
            ));
            this.$router.push('/manage/orderSetManifestDetail');
        },
        resetSubStatus() { /* 重置子状态 */
            this.form.dealState = ''
            this.form.assignState = ''
            this.form.ensureState = ''
        },
        onSelectSubStatus(emitObj,formItem,indx){
            this.tabs.activeName = indx
            this.resetSubStatus();
            this.form[formItem] = emitObj.value
            this.getOrderList()
        },
        mapFindCar(dispatchMode) {
            let res = '';
            switch (dispatchMode) {
                case 0: res = '指派用车'; break;
                case 1: res = '一口价找车'; break;
                case 2: res = '竞价找车'; break;
                case 3: res = '招标用车'; break;
                case -1: res = '询价用车'; break;
                case 4: res = '询报价用车'; break;
                default: res = ''; break;
            }
            return res;
        },
        calcCDTime(val) {
            let m;
            if(val){
                m = Math.floor(val/1000);
            } else {
                let a = moment()
                let b = moment(this.detail.order.biddingVO.end)
                m = b.diff(a, 'seconds')

            }          
            if (this.cdTmIns) {
                clearInterval(this.cdTmIns)
                this.bidDay = 0
                this.bidHour = 0
                this.bidMinute = 0
                this.bidSecond = 0
            }
            if (m > 0) {
                this.cdTmIns = setInterval(() => {
                    let days = moment.duration(m, 'seconds').days()
                    let hours = moment.duration(m, 'seconds').hours()
                    let minutes = moment.duration(m, 'seconds').minutes()
                    let seconds = moment.duration(m, 'seconds').seconds()

                    if (hours < 10) {
                        hours = '0' + hours
                    }
                    if (minutes < 10) {
                        minutes = '0' + minutes
                    }
                    if (m == 0 || m < 0) {
                        clearInterval(this.cdTmIns)
                    }
                    this.bidDay = days
                    this.bidHour = hours
                    this.bidMinute = minutes
                    this.bidSecond = seconds
                    m--;
                }, 1000);
            }
        },
        mapDealState(state) {
            let dealState = ''
            switch (state) {
                case 501: dealState = '待竞价'; break;
                case 502: dealState = '竞价中'; break;
                case 503: dealState = '待确认定标'; break;
                case 504: dealState = '已定标'; break;
                case 505: dealState = '已流标'; break;
                case 506: dealState = '已取消'; break;
                case 507: dealState = '待审批'; break;
                default: dealState = '-'; break;
            }
            return dealState
        },
        mapCreateType(type) {
            let createType = ''
            switch (type) {
                case "1": createType = '系统创建'; break;
                case "2": createType = '人工创建'; break;
                default: createType = '-'; break;
            }
            return createType
        },
        onHandBid(action) {
            this.confirmBidApi({ orderId: this.bid_orderId, operate: action }).then(res => {
                this.bidVisible = false
                if (action == 1) {
                    this.$message({
                        type: 'success',
                        message: '定标成功'
                    });
                } else {
                    this.$message({
                        type: 'success',
                        message: '已流标'
                    });
                }
                this.getOrderList();
            })
        },
        onConfirmBid(orderId) {
            this.queryBidDetailApi({ orderId: orderId }).then(res => {
                this.bid_orderId = orderId
                this.bidVisible = true
                this.bargainPrice = res.bargainPrice
                this.expectPrice = res.expectPrice
                this.floatingRatio = res.floatingRatio
                this.isTaskConflict = res.isTaskConflict
                if (res.carriageType == 1) {
                    this.bidContacts = res.driverName + ' / ' + res.driverPhone
                } else {
                    this.bidContacts = res.carrierName

                }
            })
        },
        onConfirmPay(){
            this.$message({
                type: 'warning',
                message: "请在小程序上完成支付操作" 
            });
        },
        onAlterOrder(orderId) {
            sessionStorage.setItem('alterOrderId', orderId)
            this.$router.push('/manage/Shipments')
        },
        geneDetails(row) {
            let desc = row.desc ? row.desc : '-'
            let comment = row.comment ? row.comment : '-'
            let emtpy = "&nbsp;&nbsp;&nbsp;"
            return desc + emtpy + comment
        },
         getImageUrl(val){
            this.srcList = ""
            this.viewImgApi({path: val})
                .then(res => {
                    if (res) {
                        this.srcList = res.img;
                    } else {
                        this.$message({
                            type: 'error',
                            message: "图片加载失败"
                        });
                    }
                }, response => {
                    this.$message({
                        type: 'error',
                        message: "图片加载失败"
                    });
                });
         },
         onCheckPicture(val) {
            if(val.isViewBase === 1){
                  this.getImageUrl(val.path)
            }else{
                this.$nextTick(()=>{
                    this.srcList = ""
                    this.srcList=val.baseUrl
                })
            }
        },
        queryReceipt() {
            let params = {
                orderId: this.detail.order.orderId,
                srcCity: this.detail.order.srcCity
            }
            this.queryReceiptApi(params).then(res => {
                let photo = res.receiptInfo;
                this.detail.order.needReceiptSrc = [];
                if (photo) {
                    this.detail.order.needReceiptSrc = photo
                } else {
                    this.detail.order.needReceiptImg = '-';
                }
            }).catch(e => { })
        },
        addhtml(key, value) {
            if (null == value) {
                return "<p>" + key + "</p>";
            } else {
                return "<p>" + key + "<span>" + value + "</span></p>";
            }
        },
        tmFormat(v) {
            if (v) {
                return moment(new Date(v)).format("MM/DD HH:mm");
            }
            return '';
        },
        //始发点弹出提示
        startHtml(monitor, lnglat, etcfenceDistance) {
            if (monitor) {
                let starthtml = "<div class='mapPopupContent' >";
                starthtml += this.addhtml("计划靠车时间：", this.tmFormat(monitor.planReachTm));
                starthtml += this.addhtml("实际靠车时间：", this.tmFormat(monitor.actualSrcGisInTm));
                starthtml += this.addhtml("计划发出时间：", this.tmFormat(monitor.planDepartTm));
                starthtml += this.addhtml("实际发车时间：", this.tmFormat(monitor.actualDepartTm));
                starthtml += this.addhtml("电子围栏半径：", etcfenceDistance);
                starthtml += this.addhtml("经纬度：", lnglat);
                starthtml += "</div>";
                return starthtml;
            }
            return "";
        },
        //经停点 和 终点 弹出提示
        otherHtml(monitor, lnglat, etcfenceDistance) {
            if (monitor) {
                let starthtml = "<div class='mapPopupContent2' >";
                starthtml += this.addhtml("预计到车时间：", this.tmFormat(monitor.preArriveTm));
                starthtml += this.addhtml("计划到车时间：", this.tmFormat(monitor.planArriveTm));
                starthtml += this.addhtml("实际到车时间：", this.tmFormat(monitor.actualArriveTm));
                starthtml += this.addhtml("电子围栏半径：", etcfenceDistance);
                starthtml += this.addhtml("经纬度：", lnglat);
                starthtml += "</div>";
                return starthtml;
            }
            return "";
        },
        //地图弹出提示
        promptMap(map, startMarker, endMarker, startLongitude, endLongitude, vectorLayer, passMarker, passCoordinate) {
            //起点提示
            this.addInfoToMarker(startMarker, startLongitude, this.startHtml(this.monitors[0], startLongitude, this.etcFenceDistanceMap.src));
            //终点提示
            this.addInfoToMarker(endMarker, endLongitude, this.otherHtml(this.monitors[this.monitors.length - 1], endLongitude, this.etcFenceDistanceMap.dest));
            //经停点
            try {
                let passZoneDatas = JSON.parse(JSON.stringify(this.monitors.splice(1, this.monitors.length - 2)));
                if (passMarker.length > 0) {
                    for (let int = 0; int < passMarker.length; int++) {
                        let marker = passMarker[int];
                        let coor = passCoordinate[int];
                        let lnglat = [coor[0], coor[1]];
                        this.addInfoToMarker(marker, lnglat, this.otherHtml(passZoneDatas[int], lnglat, this.etcFenceDistanceMap[coor[0] + coor[1]]));
                    }
                }
            } catch (e) {
                console.log(e);
            }
        },
        //绑定弹出事件
        addInfoToMarker(marker, lnglat, info) {
            let that = this;
            let popup = this.SFMap.popup();
            marker.on("click", function () {
                popup.setLatLng(lnglat).setContent(info).openOn(that.detail.map.mapIns);
            });
        },
        queryTrack() {
            this.monitors = [];
            this.etcFenceDistanceMap = {};
            let params = {
                taskId: this.detail.order.taskId,
                vehicleSerial: this.detail.order.vehicleSerial,
                trucksOnly: 1
            }
            this.queryTrackApi(params).then(res => {
                this.monitors = res.monitors;
                this.etcFenceDistanceMap = JSON.parse(res.etcFenceDistanceMap);
                //车辆实时位置显示
                this.carPosShow(this.latlngSingleConvert(JSON.parse(res.carNewestPos)), false);
                //规划GPS
                let newarr0 = []
                if (res.mainCoordinate) {
                    let arr0 = JSON.parse(res.mainCoordinate)
                    arr0.forEach(item => {
                        newarr0.push([item[1], item[0]])
                    })
                }
                //车载GPS
                let newarr1 = []
                if (res.carLatLng && res.carLatLng.result) {
                    let arr1 = JSON.parse(res.carLatLng.result)
                    arr1.forEach(item => {
                        newarr1.push([Number(parseFloat(item.zy).toFixed(6)), Number(parseFloat(item.zx).toFixed(6))])
                    })
                }
                //手机GPS
                let newarr2 = []
                if (res.phoneLatLng && res.phoneLatLng.result) {
                    let arr2 = JSON.parse(res.phoneLatLng.result)
                    arr2.forEach(item => {
                        newarr2.push([Number(parseFloat(item.zy).toFixed(6)), Number(parseFloat(item.zx).toFixed(6))])
                    })
                }
                this.detail.map.planCoordinates = newarr0
                this.detail.map.carCoordinates = newarr1
                this.detail.map.phoneCoordinates = newarr2
                this.planChange(true);
                this.carChange(true);
                this.phoneChange(true);

                //经过点显示
                let passPoint = res.passCoordinateList
                if (passPoint.length > 0) {
                    passPoint.forEach(item => {
                        item.reverse()
                    })
                    this.drawPoints(passPoint);
                }

            }).catch(e => { })
        },
        onProgessChange(val) {
            let arr = this.detail.map.phoneCoordinates
            let i = parseInt(arr.length * val / 100)
            if (arr.length > 0) {
                this.showSlidePosition(arr[i]);
            }
        },
        showSlidePosition(coordinate) {
            let myIcon = this.SFMap.circleIcon({
                iconRadius: 100,
                backgroundColor: '#FF0033',
                circleRadius: 10,
                boxShadow: '0 0 30px 5px #FF0033',
                ripple: 2,
                rippleColor: '#FF0033',
            });
            let iconMarker = this.SFMap.marker(coordinate, {
                icon: myIcon
            });
            if (this.detail.map.vectorLayer) {
                this.detail.map.vectorLayer.clear();
            }
            this.detail.map.vectorLayer.addLayer(iconMarker);
        },
        mapVehicle(code) {
            let name = ''
            this.vehicleMap.forEach(item => {
                code == item.plVehicleCode && (name = item.plVehicleType)
            })
            return name
        },
        geneTmStr(m) {
            let days = moment.duration(m, 'minutes').days()
            let hours = moment.duration(m, 'minutes').hours()
            let minutes = moment.duration(m, 'minutes').minutes()
            return (days ? days : '-') + '天' + (hours ? hours : '-') + '时' + (minutes ? minutes : '-') + '分'
        },
        myTimeFormat(val) {
            //单位是毫秒
            var d = moment.duration(val, 'milliseconds');
            // d.seconds() + '秒';
            return (Math.floor(d.asDays()) + '天' + d.hours() + '时' + d.minutes() + '分')
        },
        mapState(state) {
            let stateName = ''
            switch (state) {
                case 0: stateName = '全部'; break;
                case 1: stateName = '待接单'; break;
                case 2: stateName = '待装货'; break;
                case 3: stateName = '运输中'; break;
                case 4: stateName = '收货中'; break;
                case 5: stateName = '已取消'; break;
                case 10: stateName = '已完成'; break;
                case 11: stateName = '待结算'; break;
                case 12: stateName = '异常'; break;
                case 9: stateName = '已中止'; break;
                case 99: stateName = '待指派人车'; break;
                case 98: stateName = '已指派人车'; break;
                case 97: stateName = '未确认收货'; break;
                case 96: stateName = '已确认收货'; break;
                default: stateName = '-'; break;
            }
            return stateName
        },
        clear(layer) {
            if (layer.length > 0) {
                layer[0].remove()
            }
        },
        planChange(val) {
            if (val) {
                this.clear(this.detail.map.planLayer)
                if (this.detail.map.planCoordinates.length > 0) {
                    this.draw(this.detail.map.planCoordinates, this.detail.map.planLayer, '#00bcd4', 10)
                }
            } else {
                this.clear(this.detail.map.planLayer)
            }
        },
        carChange(val) {
            if (val) {
                this.clear(this.detail.map.carLayer)
                if (this.detail.map.carCoordinates.length > 0) {
                    this.draw(this.detail.map.carCoordinates, this.detail.map.carLayer, '#1919fe')
                }
            } else {
                this.clear(this.detail.map.carLayer)
            }
        },
        phoneChange(val) {
            if (val) {
                this.clear(this.detail.map.phoneLayer)
                if (this.detail.map.phoneCoordinates.length > 0) {
                    this.draw(this.detail.map.phoneCoordinates, this.detail.map.phoneLayer, '#DC1E32', 7)
                }
            } else {
                this.clear(this.detail.map.phoneLayer)
            }
        },
        onCheckDetail(row) {
            let orderId = row.orderId;
            this.checkDetailOrderId = orderId;
            if(row.deliveryFlag == 1) {
                this.detailDeliveryFlag = true;
                this.getGoodListInfo();
            }else{
                this.detailDeliveryFlag = false;
            }
            let params = {
                orderId: orderId
            }
            this.loading = true
            this.mode = '1'
            this.detail.order.needReceiptImg = ''
            this.detail.order.needReceiptSrc = []
            this.getOrderDetailApi(params).then(res => {
                this.orderDetailVisible = true;
                let obj = this.detail.order
                obj.approvalName = res.approvalName
                obj.approvalTmStr = res.approvalTmStr
                obj.approvalStateStr = res.approvalStateStr

                obj.payState = res.payState
                obj.deleteReason = res.deleteReason
                obj.requireType = res.requireType
                obj.orderId = res.orderId
                obj.needReceipt = res.needReceipt
                obj.planArriveTm = res.planArriveTm
                obj.reachTm = res.reachTm
                obj.totalPrice = res.totalPrice
                obj.needReceipt = res.needReceipt
                obj.dataOwner = res.dataOwner
                obj.projectName = res.projectName
                obj.distance = res.distance
                obj.runTm = res.runTm
                obj.cargoInfo = res.cargoInfo
                obj.cargoWeight = res.cargoWeight
                obj.cargoVolume = res.cargoVolume
                obj.mode = res.mode
                obj.carType = res.carType
                obj.vehicleType = res.vehicleType
                obj.vehicleLength = res.vehicleLength
                obj.comment = res.comment
                obj.priceRule = res.priceRule
                obj.price = res.price
                obj.passZones = res.passZones
                obj.saasRouteInfos = res.saasRouteInfos
                obj.opLogs = res.opLogs
                obj.srcCity = res.srcCity
                obj.vehicleSerial = res.vehicleSerial
                obj.carrierType = (res.carrierType == '1' ? '个人' : res.carrierType == '2' ? (res.childCarrierName ? res.childCarrierName : '') : '-')
                obj.driver = (res.driverName ? res.driverName : '') + ' ' + (res.driverPhone ? res.driverPhone : '')
                obj.taskId = res.taskId
                obj.statusName = this.mapState(res.orderState)
                obj.state = res.orderState
                obj.deductionInfoResponses = res.deductionInfoResponses
                obj.outerOrderId = res.outerOrderId
                obj.outerCustomerId = res.outerCustomerId
                obj.quantity = res.quantity
                obj.biddingVO = res.biddingVO
                obj.dispatchMode = res.dispatchMode
                obj.cargoComment = res.cargoComment
                if (res.dispatchMode == 2) {
                    obj.biddingVO.start = moment(res.biddingVO.biddingStartTm).format('YYYY-MM-DD HH:mm')
                    obj.biddingVO.end = moment(res.biddingVO.biddingEndTm).format('YYYY-MM-DD HH:mm')
                }
                obj.status.status1 = false
                obj.status.status2 = false
                obj.status.status3 = false               
                if (res.orderState == '1') {
                    if( res.payState && res.payState == 1){
                        obj.status.status1 = true
                        this.calcCDTime(res.payEndTime)
                    }
                    if (res.dispatchMode == 2) {
                        if (res.biddingVO.dealState == 501) {
                        } else if (res.biddingVO.dealState == 502 || res.biddingVO.dealState == 503) {
                            obj.status.status1 = true
                            if (res.biddingVO.dealState == 502) {
                                this.calcCDTime()
                            }
                        } else if (res.biddingVO.dealState == 504) {
                            obj.status.status3 = true
                            let vo = obj.biddingVO
                            if (vo.floatPercentage) {
                                vo.floatPercentage = (vo.floatPercentage.indexOf('-') > -1 ? vo.floatPercentage : ('+' + vo.floatPercentage))
                            }
                        } else {
                            obj.status.status2 = true
                        }
                        obj.statusName = this.mapDealState(res.biddingVO.dealState)
                    }
                } else if (res.orderState == '2') {
                } else if (res.orderState == '3' || res.orderState == '4') {
                    obj.status.status1 = true
                } else {
                    obj.status.status2 = true
                }

                

                if (res.needReceipt == '1') {
                    this.queryReceipt();
                }

                let tplState = res.orderState;
                if (tplState == '3' || tplState == '4' || tplState == '9' || tplState == '10'|| tplState == '11') {
                    this.onToggleMode()
                }
            }).catch(e => { }).finally(() => {
                this.loading = false
            });
        },
        eCloseCancel() {
            this.$refs.cancelFormRef.resetFields();
        },
        onCancelOrder(row) {
            this.cancelForm.orderId = row.orderId
            this.cancelVisible = true
        },
        onCancelConfirm() {
            let params = {
                orderId: this.cancelForm.orderId
                , source: 'SAAS_WEB'
                , deleteReason: this.cancelForm.deleteReason
                , deleteReasonDesc: this.cancelForm.deleteReasonDesc
            }
            this.$refs.cancelFormRef.validate((valid) => {
                if (valid) {
                    this.cancelLoading = true
                    this.cancelOrderApi(params).then(res => {
                        this.$message({
                            type: 'success',
                            message: '取消成功'
                        });
                        this.cancelVisible = false
                        this.getOrderList();
                    }).catch(e => { }).finally(() => { this.cancelLoading = false });
                }
            })

        },
        onAcceptOrder(row) {
            let params = {
                orderId: row.orderId
                , shippingState: 2
            }
            let str1 = '';
            let strbtnl = '';
            if(row.deliveryFlag===1) {
                str1 = "确认收货前请先核实货物信息";
                strbtnl = '确认收货';
            }else{
                str1 = "确定收货？";
                strbtnl = '确定';
            }
            this.$confirm(str1, "提示", {
                confirmButtonText: strbtnl,
                cancelButtonText: "取消",
                type: "warning",
            }).then(() => {
                this.ensureOrderApi(params).then(res => {
                    this.$message({
                        type: 'success',
                        message: '收货成功'
                    });
                    this.getOrderList();
                }).catch(e => { });
            }).catch(() => {
                this.$message({
                    type: "info",
                    message: "取消确认",
                });
            });
        },
        //显示当前车辆位置
        carPosShow(carNewestPosMap, isRequest) {
            if (this.detail.map.carNewestPosMarker) {
                this.detail.map.vectorLayer2.removeLayer(this.detail.map.carNewestPosMarker);
            }
            if (carNewestPosMap && carNewestPosMap.length > 0) {
                // 自定义图片图标
                let myIcon = this.SFMap.icon({
                    iconUrl: document.querySelector("#vehicleCurrentPosImg").src, // 图片路径
                    iconSize: [30, 30]
                });
                this.detail.map.carNewestPosMarker = this.SFMap.marker(carNewestPosMap, {
                    icon: myIcon
                });
                this.detail.map.vectorLayer2.addLayer(this.detail.map.carNewestPosMarker);
            }
        },
        latlngSingleConvert(latlng) {
            let latlngArray = []
            if (!latlng) {
                return latlngArray;
            }
            let zx = parseFloat(latlng[0]);
            let zy = parseFloat(latlng[1]);
            if (0.0 == zx && 0.0 == zy) {
                return latlngArray;
            }
            latlngArray.push(zy);
            latlngArray.push(zx);
            return latlngArray;
        },
        drawPoints(coordinates) {
            if (this.detail.map.pointLayer) {
                this.detail.map.pointLayer.clearLayers()
            }
            let startMarker = this.SFMap.marker(coordinates[0], { iconIndex: 'start' });
            let endMarker = this.SFMap.marker(coordinates[coordinates.length - 1], { iconIndex: 'end' });
            let passMarker = [];
            let pCoordinate = [];
            for (let i = 1; i < coordinates.length - 1; i++) {
                passMarker.push(this.SFMap.marker(coordinates[i], { iconIndex: 'pass' }));
                pCoordinate.push(coordinates[i]);
            }
            this.detail.map.pointLayer = this.SFMap.vectorLayer({ map: this.detail.map.mapIns, features: [startMarker, ...passMarker, endMarker] });
            //弹出提示事件
            if (this.monitors.length >= 2) {
                this.promptMap(this.detail.map.mapIns, startMarker, endMarker, coordinates[0], coordinates[coordinates.length - 1], this.detail.map.vectorLayer, passMarker, pCoordinate);
            }
        },
        draw(coordinates, layer, color, width) {
            let c = color ? color : "#3388ff"
            let tplLayer = this.SFMap.polyline(coordinates, {
                map: this.detail.map.mapIns,
                color: c,
                opacity: 1,
                weight: (width ? width : 3),
                showSymbol: true,
                symbol: [{
                    type: 'arrow',
                    repeat: 50,
                    offset: 15,
                    rotate: false,
                    color: '#ffffff',
                    symbol: undefined
                }]
            });
            layer[0] = tplLayer
            this.detail.map.mapIns.fitBounds(tplLayer.getBounds());
        },
        eOpenDetail() {},
        initMap() {
            if (!this.detail.map.mapIns) {
                this.detail.map.mapIns = this.SFMap.map("map", {
                    center: [22.524729, 113.940159],
                    zoom: 12
                });
                this.detail.map.vectorLayer = this.SFMap.vectorLayer({ map: this.detail.map.mapIns });
                this.detail.map.vectorLayer2 = this.SFMap.vectorLayer({ map: this.detail.map.mapIns });
            }
        },
        getOrderList() {
            let params = Object.assign({}, this.form)
            this.table = []
            this.loading = true
            if (params.createTm && params.createTm.length > 0) {
                params.start = params.createTm[0] + ' 00:00:00'
                params.end = params.createTm[1] + ' 23:59:59'
            }
            if (params.planDepartTm && params.planDepartTm.length > 0) {
                params.planDepartStartTm = params.planDepartTm[0] + ' 00:00:00'
                params.planDepartEndTm = params.planDepartTm[1] + ' 23:59:59'
            }else{
                params.planDepartStartTm = null
                params.planDepartEndTm = null
            }
            /* let [state] = [...params.orderState].reverse()
            params.orderState = state */
            params.orderState = this.tabs.activeName == 0 ? '' : this.tabs.activeName;
            params.dataOwners = params.dataOwner == '' ? null : [params.dataOwner];
            /* delete params.dataOwner */
            /* delete params.createTm */
            /* delete params.planDepartTm */
            this.getOrderListApi(params).then(res => {
                sessionStorage.setItem('orderListQueryParams', JSON.stringify(params)) /* 设置订单列表的查询条件 */
                res.saasListResponses.forEach(item => {
                    item.orderStateName = this.mapState(item.orderState)
                    item.needReceiptName = item.needReceipt == 1 ? (item.receiptType == 2 ? '电子+纸质回单' : '电子回单') : '不需要'
                    return item
                })
                res.counts.forEach(i => {
                    this.tabs['label' + i.orderState] = this.mapState(i.orderState) + '（' + i.orderCount + '）';
                    if (params.orderState == i.orderState) {
                        this.total = i.orderCount
                    }
                    return i;
                });
                this.table = res.saasListResponses;
            }).catch(e => { }).finally(() => {
                this.loading = false
            });
        },
        onExport() {
            let params = Object.assign({}, this.form)
            this.exportLoading = true
            if (params.createTm && params.createTm.length > 0) {
                params.start = params.createTm[0] + ' 00:00:00'
                params.end = params.createTm[1] + ' 23:59:59'
            }
            if (params.planDepartTm && params.planDepartTm.length > 0) {
                params.planDepartStartTm = params.planDepartTm[0] + ' 00:00:00'
                params.planDepartEndTm = params.planDepartTm[1] + ' 23:59:59'
            }
            delete params.createTm
            delete params.planDepartTm

            params.orderState = this.tabs.activeName == 0 ? '' : this.tabs.activeName;
            params.dataOwners = params.dataOwner == '' ? null : [params.dataOwner];
            
            this.exportApi(params).then(res => {
                window.open(this.getHostUrl() + "/saas/orderCore/downLoadFile?objectName=" + res.filePath)
            }).catch(e => { }).finally(() => {
                this.exportLoading = false
            });
        },
        getHostUrl() {
            return location.protocol + "//" + location.host;
        },
        showDownload(url) {
            let downloadbtn = `<a href="${url}">点击下载导出的Excel文件</a>`
            this.$alert(downloadbtn, '下载', {
                confirmButtonText: '取消',
                customClass: 'css-alert',
                dangerouslyUseHTMLString: true,
                callback: action => { }
            });
        },
        onReset() {
            Object.assign(this.form, this.$options.data().form)
        },
        lineList(row) {
            return '<span class="point src"></span>' + row.srcAddr + '<br><span class="point dest"></span>' + row.destAddr
        },
        onSearch() {
            this.resetSubStatus();
            this.getOrderList();
        },
        onTabsClick(activeIndex) {
            this.resetSubStatus();
            this.tabs.activeName = activeIndex
            this.form.pageNum = 1;
            this.getOrderList()
        },
        onSizeChange() { },
        onCurrentChange(val) {
            this.form.pageNum = val;
            this.getOrderList()
        },
        initMapData() {
            this.detail.map.phoneGPS = true;
            this.detail.map.carGPS = true;
            this.detail.map.planGPS = true;
            this.progress = 0;
            if (this.detail.map.phoneLayer.length > 0) {
                this.clear(this.detail.map.phoneLayer)
            }
            if (this.detail.map.carLayer.length > 0) {
                this.clear(this.detail.map.carLayer)
            }
            if (this.detail.map.planLayer.length > 0) {
                this.clear(this.detail.map.planLayer)
            }
            if (this.detail.map.pointLayer) {
                this.detail.map.pointLayer.clearLayers()
            }
        },
        onToggleMode() {
            if (this.mode == '1') {
                this.mode = '2'
                this.initMapData();
                this.queryTrack();
                setTimeout(() => {
                    this.initMap()
                }, 0)
            } else {
                this.mode = '1'
            }
        },
        getParamsFromSession() {
            let params = JSON.parse(sessionStorage.getItem('orderListQueryParams'))
            if (params) {
                Object.assign(this.form, params) /* 回填切换tab保留查询条件 */
                this.isDataFromSessionStrorage = true
            }
        }
    },
    watch: {

    },
    created() {
        let orderId = sessionStorage.getItem('orderId')
        sessionStorage.removeItem('orderId');
        if (orderId) {
            this.onCheckDetail({orderId:orderId})
        }
        let menuInterval = setInterval(() => {
            let map = JSON.parse(sessionStorage.getItem('menuMap'))
            if (map) {
                clearInterval(menuInterval)
                let submenuList = map['OrderList'].split('-');
                submenuList.forEach((item, i) => {
                    this.show[item] = true;
                });
            }
        }, 30);
        this.initPlaceApi({}).then(res => {
            let arr = [{ label: "全部", value: '' }]
            this.dataOwner = arr.concat(res.dataOwner)
        }).catch(e => { });
    },
    mounted() {
        let startTm = moment().format('YYYY-MM-DD')
        let endTm = moment(startTm).add(6, 'day').format('YYYY-MM-DD')
        this.getParamsFromSession();
        if (!this.isDataFromSessionStrorage) {
            this.form.planDepartTm = [startTm, endTm]
        }
        this.getOrderList()
    },
    filters: {
        formatMyTime(val) {
            if (val){
                return moment(new Date(val)).format("YYYY年MM月DD日");
            }
            return val;
        }
    }
}